import React, { useContext, useRef } from "react";
import MyContext from "../context/MyContext";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { registerUser } from "../helpers/apiCalls";
import ErrorDisplay from "./ErrorDisplay";

const Register = () => {
  const { register, handleSubmit, watch } = useForm();
  const context = useContext(MyContext);
  const { setUser, setError } = context;
  const history = useHistory();

  let password = useRef({});
  password = watch("password", "");

  const onSubmit = async (data) => {
    let res = await registerUser(data);
    if (res.error) {
      return setError(res.error);
    }
    setError({});
    setUser(res);
    history.push("/dashboard");
  };

  return (
    <div className="login-page">
      <form onSubmit={handleSubmit(onSubmit)}>
        <h2>Register</h2>
        <input
          placeholder="First Name *"
          {...register("firstName", {
            required: true,
          })}
        />
        <input
          placeholder="Last Name *"
          {...register("lastName", {
            required: true,
          })}
        />
        <input
          placeholder="Contact Number *"
          {...register("contactNumber", {
            required: true,
          })}
        />
        <input
          placeholder="Email *"
          {...register("email", {
            required: true,
          })}
        />

        <input
          placeholder="Password *"
          type="password"
          defaultValue="123456@Aa"
          {...register("password", {
            required: true,
            min: 8,
          })}
        />

        <input
          type="password"
          defaultValue="123456@Aa"
          placeholder="Repeat password *"
          {...register("password_repeat", {
            validate: (value) =>
              value === password || "The passwords do not match",
          })}
        />

        <div className="row">
          <button type="submit">Register</button>
          <Link to="/login">Login</Link>
        </div>
      </form>
      <ErrorDisplay />
    </div>
  );
};

export default Register;
